import * as React from "react";
import type { SVGProps } from "react";
const SvgSuitcase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.89 20c0 .55-.45 1-1 1s-1-.45-1-1v-.001A1.963 1.963 0 0 1 2 18.04V7.96C2 6.88 2.88 6 3.96 6H8V4c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v2h4.04C21.12 6 22 6.88 22 7.96v10.08a1.963 1.963 0 0 1-1.89 1.959V20c0 .55-.45 1-1 1s-1-.45-1-1H5.89Zm8.88-12.027a.993.993 0 0 0 .465-.001L16 7.97v10.04l-8 .02V7.99l.844-.002a.996.996 0 0 0 .317-.001l5.609-.014Zm4.404 10.03a.982.982 0 0 0-.133 0L18 18.004V7.965l2-.005V18l-.826.002ZM6 18.034l-.84.002a.991.991 0 0 0-.544.002L4 18.04 3.96 8 6 7.995v10.04ZM10 6h4V5h-4v1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSuitcase;
